import { CLOSED_EOD_GATE, type EodGate } from '@tempmee/awards';
import * as Client from '../clients/GetEodBidGate';

/**
 * Service layer for fetching the CS-5 EOD gate. This is the fail-open
 * boundary: the EOD flow is revenue-critical and must NEVER block on
 * awards-service — any error (network, timeout, 4xx/5xx, malformed
 * response) resolves to `CLOSED_EOD_GATE` instead of rejecting.
 */
export const getEodBidGateService = async (
  cycleId: string,
  applicantUserId: string,
  officeId?: string,
): Promise<EodGate> => {
  try {
    return await Client.getEodBidGate(cycleId, applicantUserId, officeId);
  } catch {
    return CLOSED_EOD_GATE;
  }
};
